import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import classes from "../../Styles/common.module.css";
import BackModal from '../BasicElements/BackModal.js';
import ConfirmModal from '../BasicElements/ConfirmModal.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const ForgetPassword = (props) => {
  const userEmailInputRef = useRef();

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  // var [generatedPassword, setGeneratedPassword] = useState('');
  // var generatedPassword = '';

  // const generatePassword = () => {
  //   const chars = '0123456789';
  //   var password = '';
  //   for (let i = 0; i < 6; i++) {
  //     const randomIndex = Math.floor(Math.random() * chars.length);
  //     password += chars[randomIndex];
  //   }
  //   generatedPassword = password;
  // };

  const generatePassword = () => {
    const length = 12; // Length of the password
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password;
    };
    const encryptPassword = (password) => {
        return common.c_EncryptData(password.trim()).toString();
    };


  const onKeyDown = (event) => { 
		if (event.key === "Enter") 
    handleConfirm();
	}

  // useEffect(() => {
  //   var inputText = document.getElementById("EMAIL");
  //   var saveBtn = document.getElementById("btnSave");
  //   if (inputText && saveBtn) {
  //     inputText.onkeydown = (e) => { if (e.key === "Enter") saveBtn.click(); }
  //   }
  // }, [props.editData]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
		setHasChanges(false);
    props.onHide();
  };

  const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

  const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
		var flag = true;

    if (editData.EMAIL === undefined) {
			flag = false;
      setInputError((prevState) => ({
        ...prevState,
        EMAIL: ("Email could not be empty."),
      }));
    }
    if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
      setShowConfirmModal(true);
    }
  }

  const handleConfirmModal = () => {
    ForgetPassword();
    setShowConfirmModal(false); // Hide confirm modal
		hideModal();
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };

  function ForgetPassword() {
    if (editData.EMAIL !== undefined) {
      let functionName = "";
      try {
        functionName = ForgetPassword.name;
        props.onLoading(true, "Sending email, please wait...");
        // var encrypted = common.c_EncryptData(generatedPassword);
        const generatedPassword = generatePassword();
        const encryptedPassword = encryptPassword(generatedPassword);
        const data = {
          EMAIL: editData.EMAIL,
          DEFAULT_PASSWORD: encryptedPassword.toString(),
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };
        http
          .post("api/login/ForgetPassword", data, { timeout: 5000 })
          .then((response) => {
            if (response.data.VALID === "EMAIL_INVALID") {
              setEditData(prevState => ({
                ...prevState,
                ERROR_MSG: response.data.ERROR_MSG,
              }))
            }
            else {
              toast.success("Forget password successfully. Please check your email.");
              hideModal();
              props.showHideLoginModal();
            }
          })
          .catch((err) => {
            toast.error("User not found. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        toast.error("Failed to forget password. Please try again.");
        props.onLoading(false, "Loading...");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  };

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (name + " could not be empty."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }
  
    const inputUnrequiredHandler = (event) => {
      let functionName = "";
      
      try {
        functionName = inputUnrequiredHandler.name;
        const id = event.target.id;
        const val = event.target.value;
      
        furtherValidateInput(id, val);
        setEditData((prevState) => ({
          ...prevState,
          [id]: val,
        }));
      } catch (err) {
        common.c_LogWebError(props.page, functionName, err);
      }
      setHasChanges(true);
    }
  
    function furtherValidateInput(id, val) {
      if (id === "EMAIL") {
        if (!common.EMAIL_REGEX.test(val) && val !== "") {
          setInputError((prevState) => ({
            ...prevState,
            [id]: ("Please enter a proper email."),
          }));
          return false;
        } else {
          setInputError((prevState) => ({
            ...prevState,
            [id]: (""),
          }));
          return true;
        }
      }
      else {
        return true;
      }
    }

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered dialogClassName="login-modal">
  			<div className="login-modal-content">
          <Modal.Header style={{ backgroundColor: "#fff" }}>
            <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
              <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Forgot Password</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <h5
              style={{
                fontSize: '1.25rem',
                fontWeight: '500',
                color: '#a5a5a5ff',
                textAlign: 'center',
                marginBottom: '30px',
                lineHeight: '1.6',
              }}
            >
              Enter the email address associated with your account, and we'll send you a password reset link.
            </h5>
              <div className="floating-label-group">
                <input
                  type="text"
                  id="EMAIL"
                  name="Email"
                  placeholder=" "
                  value={editData.EMAIL}
                  onChange={inputUnrequiredHandler}
                  onKeyDown={onKeyDown}
                  errorMessage={inputError.EMAIL}
                  ref={userEmailInputRef}
                  className="form-control"
                  autoComplete="off"
                />
                <label htmlFor="EMAIL">Email Address*</label>
                {inputError.EMAIL && (
								<div className={classes.invalidMessage}>{inputError.EMAIL}</div>
							)}
              </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Comp.Button
                id="btnCancel"
                type="cancel"
                onClick={handleBack}
              >
                <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
              </Comp.Button>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <Comp.Button id="btnSave" onClick={handleConfirm}>
                <FontAwesomeIcon icon={faCheck} />&nbsp; Confirm
              </Comp.Button>
              
              {editData.ERROR_MSG && editData.ERROR_MSG.split('\n').map((line, index) => (
                <p key={index} style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{line}</p>
              ))}
              {/* <p style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{editData.ERROR_MSG}</p> */}
            </div>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
        prop="Confirm to save"
      >
        Are you sure you want to reset password?
      </ConfirmModal>
    </>
  );
};

export default ForgetPassword;